import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http } from "@/lib/api";

export default function ConfirmFollow() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [slug, setSlug] = useState(null);
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    http.get(`/followers/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => { setState("ok"); setSlug(r.data.brand_slug); })
      .catch(() => setState("error"));
  }, [params]);
  return (
    <div className="bp-container py-24 text-center max-w-xl">
      {state === "loading" && <div className="animate-pulse h-6 w-40 bg-neutral-200 mx-auto" />}
      {state === "ok" && (
        <>
          <h1 className="font-serif text-4xl mb-4">Subscription confirmed</h1>
          <p style={{ color: "var(--bp-text-secondary)" }}>You&apos;ll be notified when this profile changes.</p>
          {slug && <Link to={`/brands/${slug}`} className="bp-link mt-6 inline-block">Back to profile →</Link>}
        </>
      )}
      {state === "error" && (
        <>
          <h1 className="font-serif text-4xl mb-4">Invalid or expired link</h1>
          <Link to="/" className="bp-link">Back home →</Link>
        </>
      )}
    </div>
  );
}
